<!-- Header -->
<app-header></app-header>

<div class="master" #main>
  <div class="container__main">
    <div class="container__items">
      <div class="label__main">
        <span class="title__main">
          Next generation digital banking
        </span>
        <div class="description__main">
          <span class="description">Take your financial life online. Your Easybank account will be a one-stop for
            spending, saving budgeting, investing, and much more.</span>
        </div>
        <button class="button__header">
          <span class="span__header">Request Invite</span>
        </button>
      </div>
      <div class="image__main">
      </div>
      <div class="image__phone">
      </div>
    </div>
  </div>

  <!--  -->
  <div class="container__easy__bank">
    <div class="master__item">
      <div class="container__items__easy__bank">
        <h1 class="title__easy__bank">Why choose Easybank?</h1>
        <span class="span__desciption__easy__bank">We leverage Open Banking to turn your bank account into your
          financial
          hub. Control your finances like never before.</span>
      </div>

      <!-- Choose -->
      <div class="container__chose">
        <div class="container__items__chose">
          <div class="items__chose">
            <div class="container__choose__items">
              <div class="image__chose --online"></div>
              <div class="title__chose">
                Online Banking
              </div>
              <div class="description__choose">
                Our modern web and mobile applications allow you to keep track of your finances wherever you are in the
                world.
              </div>
            </div>
          </div>
          <div class="items__chose">
            <div class="container__choose__items">
              <div class="image__chose --simple"></div>
              <div class="title__chose">
                Simple Budgeting
              </div>
              <div class="description__choose">
                See exactly where your money goes each month. Receive notifications when you're close to hitting your
                limits.
              </div>
            </div>
          </div>
          <div class="items__chose">
            <div class="container__choose__items">
              <div class="image__chose --fast"></div>
              <div class="title__chose">
                Fast Onboarding
              </div>
              <div class="description__choose">
                We don't do branches. Open your account in minutes online and start taking control of your finances
                right
                away.
              </div>
            </div>
          </div>
          <div class="items__chose">
            <div class="container__choose__items">
              <div class="image__chose --api"></div>
              <div class="title__chose">
                Open API
              </div>
              <div class="description__choose">
                Magae your savings, investments, pension, and much more from one account. Tracking your money has never
                been easier.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Latest articles -->
  <div class="container__easy__bank mobile" style="background: white;">
    <div class="master__item">
      <span class="title__articles__container">Latest Articles</span>
      <div class="container__chose">
        <div class="container__items__chose">
          <div class="items__articles">
            <div class="container__choose__items --border">
              <div class="image__articles --money"></div>
              <div class="wrap__articles">
                <div class="autors__articles">By Claire Robinson</div>
                <div class="title__articles">
                  <a href="#">Receive money in any currency with no fees</a>
                </div>
                <div class="description__articles">
                  The world is hetting smaller and we're becoming more mobile. So why should you be forced to only
                  receive
                  money in a single ...
                </div>
              </div>
            </div>
          </div>
          <div class="items__articles">
            <div class="container__choose__items --border">
              <div class="image__articles --treat"></div>
              <div class="wrap__articles">
                <div class="autors__articles">By Wilson Hutton</div>
                <div class="title__articles">
                  <a href="#"> Treat yourself without worrying about money</a>
                </div>
                <div class="description__articles">
                  Our simple budgeting feature allows you to separate out your spending and set realistic limits each
                  month. That means you...
                </div>
              </div>
            </div>
          </div>
          <div class="items__articles">
            <div class="container__choose__items --border">
              <div class="image__articles --plan"></div>
              <div class="wrap__articles">
                <div class="autors__articles">By Wilson Hutton</div>
                <div class="title__articles">
                  <a href="#">Take your Easybank card wherever you go</a>
                </div>
                <div class="description__articles">
                  We want you to enkoy your travels. This is why we don't charge any fees on purchases while you're
                  abroad. We'll event show you...
                </div>
              </div>
            </div>
          </div>
          <div class="items__articles">
            <div class="container__choose__items --border">
              <div class="image__articles --beta"></div>
              <div class="wrap__articles">
                <div class="autors__articles">By Claire Robinson</div>
                <div class="title__articles">
                  <a href="#"> Our invite-only Beta accounts are now live! </a>
                </div>
                <div class="description__articles">
                  After a lot of hard work by the whole team, we're excited yo launch our closed beta. It's easy to
                  request an invite through the site ...
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <app-footer></app-footer>
</div>
